import { Link } from "react-router-dom";
import { GiTakeMyMoney } from "react-icons/gi";
import "./header.css";

function Header() {
  return (
    <header className="headere">
      <section className="containere">
        <nav className="nav">
          <Link to="/" className="a">
            <h1 className="logo">
              Guia Financeiro
              <GiTakeMyMoney className="money-icon" />
            </h1>
          </Link>
          <ul className="link">
            <li><Link className="a" to="/noticia">Últimas Notícias</Link></li>
            <li><Link className="a" to="/politica">Politica</Link></li>
            <li><Link className="a" to="/fofoca">Fofoca</Link></li>
            <li><Link className="a" to="/investimento">Investimento</Link></li>
            <li><Link className="a" to="/financas">Finanças</Link></li>
            <li><Link className="a" to="/divida">Dívidas</Link></li>
           
          </ul>
        </nav>
      </section>
    </header>
  );
}

export default Header;
